<template>
    <steps-manager>
        <template #step>
            <div class="container-validation">
                <div class="select-input-validation">
                    <div class="select-validation">
                        <ui-select2
                            v-model="filters.block"
                            :data="blockOptions"
                            :loading="loader.block"
                            label="Selecione a quadra:"
                            return-value="value"
                            design="mgb-15 br-all"
                            size="lg"
                            placeholder="Todas"
                            @input="filterHandler"
                        />
                    </div>
                </div>

                <div class="table-validation">
                    <ui-table
                        :data="tableDataComputed"
                        :columns="tableColumns"
                        :loading="loader.table"
                        :select-column-menu="false"
                        not-found-icon="fa fa-file-contract"
                        not-found-text="Não foi possível encontrar nenhum cliente neste lançamento"
                        max-height="250px"
                        name="reserves-property"
                        tr-component="launch/control/reserves-table-line"
                    />
                </div>

                <div class="button-print-reservations">
                    <ui-button
                        :loading="loader.print"
                        design="success mw-150 md"
                        @click="printHandler">
                        Imprimir Reservas
                    </ui-button>
                </div>
            </div>
        </template>
    </steps-manager>
</template>

<script>
	import { uiTable } from '@/components/ui'
	import { uiButton } from '@/components/ui/buttons'
	import { uiSelect2 } from '@/components/ui/form'
    import stepsManager from '../components/steps-manager'

    import { availability, product } from '@/services/axios'

    import { utilMixin } from '@/mixins'

    import { mapGetters } from 'vuex'

    const defaultLoader = () => ({
        table: false,
        block: false,
        print: false
    })

    export default {
        name: 'ui-reservation',

        components: {
            stepsManager,
            uiTable,
            uiSelect2,
            uiButton
        },

        mixins: [utilMixin],

        data() {
            return {
                filters: {
                    block: null
                },
                loader: { ...defaultLoader() },
                tableData: [],
                tableColumns: [
                    { title: 'Quadra' },
                    { title: 'Lote' },
                    { title: 'Metragem' },
                    { title: 'Valor' },
                    { title: '' }
                ],
                blockOptions: [],
                unsubscribe: null
            }
        },

        computed: {
            ...mapGetters('launchDay', {
                definitions: 'getDefinitions',
                control: 'getControl'
            }),
            /**
             * Computed property que define se a disponibilidade à que esta unidade pertence,
             * é do tipo horizontal
             */
            isHorizontal() {
                return this.control.deal &&
                    this.control.deal.product &&
                    this.control.deal.product.availability &&
                    this.control.deal.product.availability.type === 'horizontal'
            },
            /**
             * Computed property que filtra as unidades listadas, para mostrar apenas as unidades
             * disponíveis
             */
            tableDataComputed() {
                return this.tableData.filter(item => item.situation === 'available')
            }
        },

        created() {
            /** Subscreve para uma mutation */
            this.unsubscribe = this.$store.subscribe((mutation) => {
                if (mutation.type === 'launchDay/SET_CONTROL_DEAL') {
                    if (!this.isHorizontal) {
                        this.tableColumns = [
                            { title: 'Torre' },
                            { title: 'Andar' },
                            { title: 'Unidade' },
                            { title: 'Metragem' },
                            { title: 'Valor' },
                            { title: '' }
                        ]
                    }
                    this.loadBlocks()
                    this.loadData()
                }
            })
        },

        beforeDestroy() {
            this.unsubscribe()
            this.$root.$off('launch-control-reserve-search')
        },

        methods: {
            /**
             * Busca as quadras/torres de um empreendimento de acodo com o ID da disponibilidade
             */
            loadBlocks() {
                this.loader.block = true
                availability.getBlocks(this.definitions.product.availability_id)
                    .then(response => {
                        this.blockOptions = Object.values(response.data).map(item => {
                            const label = this.isHorizontal ? `Quadra ${item.block}` : `Torre ${item.block}`
                            return { label, value: item.block }
                        })
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log(error)
                    })
                    .finally(() => {
                        this.loader.block = false
                    })
            },
            /**
             * Carrega os dados das unidades do empreendimento vindulado ao lançamento, para permitir
             * reservas para o negócio
             */
            loadData: async function () {
                try {
                    this.loader.table = true
                    let response = null
                    if (this.$mx_hasValue(this.filters.block)) {
                        const filter = this.filters.block
                        response = await availability.getBlockUnits(this.definitions.product.availability_id, filter)
                        this.tableData = [...response.data]

                    } else {
                        response = await product.getAvailability(this.definitions.product.id)
                        this.tableData = response.data &&
                                response.data.availability &&
                                response.data.availability.units
                                    ? [...response.data.availability.units]
                                    : []
                    }

                } catch (error) {
                    if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    console.log(error)

                } finally {
                    this.loader.table = false
                }
            },
            /**
             * Event handler que trata o evento de quando a filtragem por uma quadra específica é
             * requerida
             */
            filterHandler() {
                this.tableData = []
                this.loadData()
            },
            /**
             * Event handler que trata o evento de quando a impressão dos comprovantes das reservas é
             * requerida
             */
            printHandler: async function () {
                try {
                    this.loader.print = true
                    const payload = {
                        reserves: Object.values(this.control.deal.reserves)
                            .map(reserve => {
                                reserve.qr_code = this.control.deal.qr_code

                                return reserve
                            })
                            .filter(reserve => reserve.status === 'reserved'),
                        availability: { ...this.control.deal.product.availability }
                    }
                    this.$root.$emit('print-reserve-voucher', payload)

                } catch (error) {
                    if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    console.log(error)

                } finally {
                    this.loader.print = false
                }

            }
        }
    }
</script>

<style lang="stylus" scoped>
	@import 'styles.styl';
</style>